import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';


/**
 * Use the current instance of the TranslateService to translate a given translation key before navigation. Useful to translate route data,
 * e.g. for the route title.
 *
 * @param {string} key The translation key to translate
 * @returns {() => Observable<string>} The translated string as an observable
 */
export const resolveTranslated: (key: string) => ResolveFn<Observable<string>> = (key: string): () => Observable<string> => {
  return () => inject(TranslateService).get(key);
};
